export type MetamodelPreviewLabels = {
  closePreviewLabel?: string;
  previewMetamodelLabel?: string;
};

export const defaultMetamodelPreviewLabels: Required<MetamodelPreviewLabels> = {
  closePreviewLabel: 'Close Preview',
  previewMetamodelLabel: 'Preview Metamodel',
};
